// QuickActions.js - ACTUALIZADO con Finanzas
import React from "react";
import { useNavigate } from "react-router-dom";
import { Box, Button, Typography, useTheme } from "@mui/material";
import {
  People,
  Assignment,
  Receipt,
  ContactMail,
  Business,
  Description,
  LocalShipping,
  Handshake,
  Add as AddIcon,
  Sell,
  ShoppingCart,
} from "@mui/icons-material";

const QuickActions = () => {
  const navigate = useNavigate();
  const theme = useTheme();

  const actions = [
  {
    label: "Nuevo Cliente",
    icon: <People />,
    path: "/clients?new=true",
    color: "#1abc9c",
  },
  {
    label: "Nuevo Comercial",
    icon: <Handshake />,
    path: "/commercials?new=true",
    color: "#00bcd4",
  },
  {
    label: "Nuevo Proveedor",
    icon: <LocalShipping />,
    path: "/suppliers?new=true",
    color: "#16a085",
  },
  {
    label: "F. Compra",
    icon: <ShoppingCart />,
    path: "/purchases?new=true",
    color: "#26c6da",
  },
  {
    label: "Nueva Propuesta",
    icon: <Description />,
    path: "/proposals?new=true",
    color: "#4dd0e1",
  },
  {
    label: "Nuevo Proyecto",
    icon: <Assignment />,
    path: "/projects?new=true",
    color: "#00838f",
  },
  {
    label: "Nueva Tarea",
    icon: <Assignment />,
    path: "/tasks?new=true",
    color: "#00acc1",
  },
  {
    label: "F. Venta",
    icon: <Sell />,
    path: "/sales?new=true",
    color: "#006064",
  },

];

  return (
    <Box>
      <Typography
        variant="h6"
        fontWeight={600}
        sx={{
          mb: { xs: 1.5, sm: 2 },
          color: "#005f65",
          fontSize: { xs: "0.9rem", sm: "1.1rem", md: "1.25rem" },
        }}
      >
        Acciones Rápidas
      </Typography>

      <Box
        sx={{
          display: "grid",
          gap: { xs: 1, sm: 1.5 },
          gridTemplateColumns: {
            xs: "repeat(2, 1fr)",
            sm: "repeat(3, 1fr)",
            md: "repeat(4, 1fr)",
            lg: "repeat(4, 1fr)",
          },
        }}
      >
        {actions.map((action, index) => (
          <Button
            key={index}
            variant="contained"
            startIcon={action.icon}
            endIcon={<AddIcon fontSize="small" />}
            onClick={() => navigate(action.path)}
            sx={{
              height: { xs: 44, sm: 48, md: 52 },
              borderRadius: { xs: "8px", sm: "10px", md: "12px" },
              textTransform: "none",
              fontWeight: 600,
              fontSize: { xs: "0.7rem", sm: "0.8rem", md: "0.85rem" },
              background: `linear-gradient(135deg, ${action.color} 0%, ${action.color}dd 100%)`,
              boxShadow: "none",
              whiteSpace: "nowrap",
              transition: "all 0.3s ease",
              position: "relative",
              overflow: "hidden",
              color: "#ffffff",
              minWidth: 0,
              px: { xs: 1, sm: 1.5, md: 2 },

              "&::before": {
                content: '""',
                position: "absolute",
                top: 0,
                left: 0,
                right: 0,
                bottom: 0,
                background:
                  "linear-gradient(135deg, rgba(255,255,255,0.12) 0%, rgba(255,255,255,0) 100%)",
                opacity: 0,
                transition: "opacity 0.3s ease",
              },

              "&:hover": {
                boxShadow: `0 10px 26px ${action.color}55`,
                transform: { xs: "none", sm: "translateY(-2px)" },
                filter: "brightness(1.08)",

                "&::before": {
                  opacity: 1,
                },
              },

              "&:active": {
                transform: "translateY(0px)",
                boxShadow: `0 4px 12px ${action.color}33`,
              },

              "& .MuiButton-startIcon": {
                marginRight: { xs: 0.5, sm: 1 },
              },
              "& .MuiButton-endIcon": {
                marginLeft: { xs: 0.25, sm: 0.5 },
              },
            }}
          >
            {action.label}
          </Button>
        ))}
      </Box>
    </Box>
  );
};

export default QuickActions;
